import { Link } from "react-router-dom";
import useLocationSearch from "../../hooks/useLocationSearch";
import { destinationChips } from "../data/mobileFallbackData";
import { resolveStateName, stateSearchParams } from "../../utils/locationState";

const destinationImageFallbacks = [
  { keys: ["goa", "calangute", "anjuna", "baga", "assagao", "palolem", "vagator"], image: "/landing/original/destination-goa.png" },
  { keys: ["kerala", "kochi", "alappuzha", "alleppey", "kumarakom", "munnar"], image: "/landing/original/destination-kerala.jpg" },
  { keys: ["rajasthan", "udaipur", "jaipur", "jaisalmer"], image: "/landing/original/destination-rajasthan.jpg" },
  { keys: ["himachal", "manali", "shimla"], image: "/landing/original/destination-himachal.jpg" },
  { keys: ["bengaluru", "bangalore", "karnataka"], image: "/landing/original/featured-card-1.jpg" },
  { keys: ["alibaug", "mumbai", "maharashtra", "lonavala"], image: "/landing/original/featured-card-3.jpg" },
];

const resolveDestinationImage = (item, name) => {
  const direct = item.image || item.image_url || item.thumbnail || item.coverImage || item.cover_image || item.photo_url;
  if (direct) return direct;
  const haystack = [name, item.city, item.state, item.country, item.display_name, item.slug].filter(Boolean).join(" ").toLowerCase();
  const matched = destinationImageFallbacks.find((entry) => entry.keys.some((key) => haystack.includes(key)));
  if (matched) return matched.image;
  return destinationChips.find((entry) => haystack.includes(String(entry.name).toLowerCase()))?.image || destinationChips[0]?.image || "";
};

export default function MobileDestinationChips({ items }) {
  const { suggestions, loading } = useLocationSearch("", { popularLimit: 40 });
  const rawDestinations = Array.isArray(items) ? items : [...suggestions, ...destinationChips];
  const destinations = Array.from(
    rawDestinations
      .reduce((map, item) => {
        const fallback = item.name || item.display_name || item.city;
        const stateName = resolveStateName(item, fallback);
        if (!stateName || map.has(stateName.toLowerCase())) return map;
        map.set(stateName.toLowerCase(), { ...item, stateName });
        return map;
      }, new Map())
      .values()
  );
  if (loading && !destinations.length) return <div className="hv-mobile-inline-loading" role="status">Loading destinations...</div>;
  if (!destinations.length) return null;
  return (
    <div className="hv-destination-row" aria-label="Popular destinations">
      {destinations.map((item) => {
        const name = item.stateName || resolveStateName(item, item.name || item.display_name || item.city);
        const image = resolveDestinationImage(item, name);
        return name ? (
        <Link
          className="hv-destination-chip"
          key={item.id || name}
          to={`/stays?${stateSearchParams(name).toString()}`}
        >
          {image ? <img src={image} alt="" loading="lazy" decoding="async" /> : <span className="hv-destination-placeholder"><i className="bi bi-geo-alt" /></span>}
          <strong>{name}</strong>
          {item.property_count ? <span>{item.property_count} stays</span> : null}
        </Link>
      ) : null})}
    </div>
  );
}
